import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import { Layout } from "@/components/Layout";
import Home from "@/pages/Home";
import Game from "@/pages/Game";
import Profile from "@/pages/Profile";
import Bonuses from "@/pages/Bonuses";
import Admin from "@/pages/admin/Admin";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/adc" element={<Admin />} />
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/slide" element={<Game />} />
              <Route path="/profil" element={<Profile />} />
              <Route path="/bonuslar" element={<Bonuses />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster theme="dark" position="top-center" richColors />
      </AuthProvider>
    </div>
  );
}

export default App;
